import React from 'react'
import Navbar from "../../components/navbar";
import "../../assets/css/style.css";
import Card from "./card";

function Dashboard({token, orgInfo}) {
	return (
		<>
			<Navbar orgInfo={orgInfo} />
			<div className="container">
				<div className="row mb-4 mt-5">
					<div className="col-xl-3 col-lg-6">
						<Card token={token} title="Total Clients" apiPath="products" preFix="" />
					</div>
					<div className="col-xl-3 col-lg-6">
						<Card token={token} title="Account Renewals" apiPath="instock" preFix="" />
					</div>
				</div>
			</div>
		</>
	)
}

export default Dashboard;